import _classPrivateFieldInitSpec from "@babel/runtime/helpers/classPrivateFieldInitSpec";
import _classPrivateFieldGet from "@babel/runtime/helpers/classPrivateFieldGet2";
import { getV2RuntimeFromDll } from "./getV2RuntimeFromDll.js";
var _registry = /*#__PURE__*/new WeakMap();
class CustomProcessorRegistry {
  constructor() {
    _classPrivateFieldInitSpec(this, _registry, new Map());
  }
  define(processorFullName, processorFunc) {
    // `namespace` should be the camelCase of the package name.
    const [namespace, processorName] = processorFullName.split(".");
    let pkg = _classPrivateFieldGet(_registry, this).get(namespace);
    if (!pkg) {
      pkg = new Map();
      _classPrivateFieldGet(_registry, this).set(namespace, pkg);
    }
    if (pkg.has(processorName)) {
      // eslint-disable-next-line no-console
      throw new Error(`Custom processor of "${processorFullName}" already registered`);
    }
    pkg.set(processorName, processorFunc);
  }
  get(namespace) {
    return _classPrivateFieldGet(_registry, this).get(namespace);
  }
}

// istanbul ignore next
function getCustomProcessorsV2() {
  const v2Kit = getV2RuntimeFromDll();
  if (v2Kit) {
    return Object.freeze({
      define(processorFullName, processorFunc) {
        return v2Kit.getRuntime().registerCustomProcessor(processorFullName, processorFunc);
      }
    });
  }
}

// istanbul ignore next
export const customProcessors = getCustomProcessorsV2() || new CustomProcessorRegistry();
//# sourceMappingURL=CustomProcessors.js.map